import { defineComponent } from "vue";
import Popup from "../../share/popup";

import "./copy.less";

export default defineComponent({
  emits: ["confirm"],
  props: {
    visible: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const onConfirmClick = () => {
      emit("confirm");
    };

    return () => (
      <Popup closeOnOverlayClick={false} position="center" visible={props.visible} width={320}>
        <div class="feiyu-web-service-pay-copy">
          <div class="feiyu-web-service-pay-copy--title">{"温馨提示"}</div>
          <div class="feiyu-web-service-pay-copy--content">
            {"请点击复制您的订单专属支付地址，并前往外部浏览器粘贴访问后，完成支付操作。"}
          </div>
          <div class="feiyu-web-service-pay-copy--button" onClick={onConfirmClick}>
            {"复制"}
          </div>
        </div>
      </Popup>
    );
  },
});
